<template>
  <!-- 退项管理 -->
  <div class="tuixiang">
    <div class="top">
      <Input v-model.trim="searchValue" @on-clear='getselectOrderList(1)' @on-enter="getselectOrderList(1)" placeholder="搜索订单号/手机号" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" />
      </Input>
    </div>

    <div class="table-cont">
      <Table @on-sort-change="changesort" @on-selection-change="selectChange" stripe :columns="columns" :data="data"></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">已选 <span>{{selectNum}}</span> 条</div>
      <Page :total="obj.total" @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" show-elevator show-total :current="pageNum" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>

    <Modal class="ivumodal" footer-hide width="800" v-model="seeShow" title="订单详情">
      <div class="ivumodal-title-impoet">本界面操作过退项后，平台会向体检者退款，请您确认此操作！</div>
      <div style="line-height:30px;"> 订单编号：{{showItem.orderNum}} 体检者姓名：{{showItem.patientName}} 体检者手机号：{{showItem.phone}} 体检类型：{{showItem.medicalType==1?'团检':'个检'}} </div>
      <div class="table-cont">
        <Table @on-sort-change="changesort" @on-selection-change="selectChange2" stripe :columns="columns2" :data="data2"></Table>
      </div>
      <div class="page-dives" style="margin-top:15px;">
        <div class="page-div-left page-div-lefts ">已选 <span>{{selectNum2}}</span> 条</div>
        <Button class="btn sure" type="success" ghost @click="piliang">批量退项</Button>
        <Page @on-page-size-change="changepeoplepage2" @on-change="changePeoplecurrent2" :total="obj2.total" show-elevator show-total :current="pageNum2" :page-size="pageSize2" show-sizer class="page-div-page" />
      </div>
      <div style="clear:both;"></div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok()">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok()">确定</Button>
      </div>
    </Modal>

    <Modal class="ivumodal" width="500" footer-hide v-model="errors" title="确认操作">
      <div class="ivumodal-cont">
        请选择需要操作的数据。
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok(1)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok(1)">确定</Button>
      </div>
    </Modal>

    <Modal class="ivumodal" width="500" footer-hide v-model="errors2" title="确认操作">
      <div class="ivumodal-cont">
        您确认要进行此操作？
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok(3)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok(2)">确定</Button>
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{alertTitle}}</Alert>
    <Spin class="zindex" fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin>

  </div>
</template>
<script>
import {
  selectOrderList,
  selectFeeItemOrderList,
  refundItem,
} from "../servers/api";
export default {
  data() {
    return {
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      searchValue: "",
      orderField: "",
      orderField2: "",
      errors: false,
      errors2: false,
      isAsc: "",
      isAsc2: "",
      pageNum: 1,
      pageNum2: 1,
      selectList: [],
      selectList2: [],
      selectNum: 0,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "订单号",
          align: "center",
          key: "orderNum",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "订单日期",
          // width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "createTime",
          render: (h, params) => {
            let a = params.row.createTime;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            }

            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "体检者姓名",
          width: 125,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "patientName",
        },
        {
          title: "体检者手机号",
          width: 140,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "phone",
        },
        {
          title: "包含项目数量",
          align: "center",
          ellipsis: true,
          width: 140,
          sortable: true,
          key: "feeItemCount",
        },
        {
          title: "操作",
          key: "awssd",
          align: "center",
          width: 110,
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  height: "28px",
                  "line-height": "28px",
                  "text-align": "center",
                  "font-size": "13px",
                  border: "1px solid #53CAC3",
                  "border-radius": "5px",
                  width: "50px",
                  "margin-left": "15px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.toXiang(params.row);
                  },
                },
              },
              "详情"
            );
          },
        },
      ],
      data: [{}],
      obj: {},
      pageSize: 20,
      pageSize2: 20,
      seeShow: false,
      columns2: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "订单日期",
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "orderDate",
          render: (h, params) => {
            let a = params.row.orderDate;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            }
            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "项目名称",
          // width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "examFeeItemName",
        },
        {
          title: "退项状态",
          // width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "refundItemStatus",
          render: (h, params) => {
            let a = params.row.refundItemStatus;
            let num = "";
            if (a == 1) {
              num = "已退项";
            }
            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "退项日期",
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "refundItemDate",
          render: (h, params) => {
            let a = params.row.refundItemDate;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            }
            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "退项人",
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "refundCreatorName",
        },
        {
          title: "操作",
          key: "awssd",
          align: "center",
          width: 110,
          render: (h, params) => {
            let a = "#eee";
            let b = "";
            if (
              params.row.refundItemStatus &&
              params.row.refundItemStatus == 1
            ) {
              a = "rgb(191,191,212)";
              b = "rgb(191,191,212)";
            } else {
              a = "#7F7F7F";
              b = "#53CAC3";
            }
            return h(
              "div",
              {
                style: {
                  height: "28px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  border: "1px solid #53CAC3",
                  "border-radius": "5px",
                  width: "65px",
                  "margin-left": "12px",
                  cursor: "pointer",
                  disabled: false,
                  color: a,
                  "border-color": b,
                },
                on: {
                  click: () => {
                    if (
                      params.row.refundItemStatus !== 1 ||
                      !params.row.refundItemStatus
                    ) {
                      this.toTui(params.row);
                    }
                  },
                },
              },
              "退项"
            );
          },
        },
      ],
      data2: [{}],
      selectNum2: 0,
      obj2: {},
      showItem: {},
      orderNum: "",
      tuiItem: {},
      idExamFeeItemList: [],
    };
  },
  created() {
    this.getselectOrderList();
  },
  methods: {
    piliang() {
      //批量退项
      if (this.selectList2.length == 0) {
        this.errors = true;
      } else {
        this.idExamFeeItemList = [];
        for (let i = 0; i < this.selectList2.length; i++) {
          this.idExamFeeItemList.push(this.selectList2[i].idExamFeeItem);
        }
        this.errors2 = true;
      }
    },
    toTui(item) {
      //点击退项
      this.idExamFeeItemList = [];
      this.idExamFeeItemList.push(item.idExamFeeItem);
      this.errors2 = true;
    },
    ok(index) {
      if (index == 1) {
        this.errors = false;
      } else if (index == 2) {
        this.isiconfontshow = true;
        let params = {
          orderNum: this.showItem.orderNum,
          idPatient: this.showItem.idPatient,
          idExamFeeItemList: this.idExamFeeItemList.join(","),
        };
        refundItem(params).then((res) => {
          if (res.data.code == 1) {
            this.isiconfontshow = false;
            this.errors2 = false;
            this.alertTitleIshow = true;
            setTimeout(() => {
              this.alertTitleIshow = false;
            }, 2000);
            this.getselectFeeItemOrderList();
          } else {
            this.isiconfontshow = false;
            this.alertTitle = res.data.msg;
            this.alertTitleIshow2 = true;
            setTimeout(() => {
              this.alertTitleIshow2 = false;
            }, 2000);
          }
        });
      } else if (index == 3) {
        this.errors2 = false;
      } else {
        this.seeShow = false;
      }
    },
    getselectFeeItemOrderList() {
      //详情列表
      this.isiconfontshow = true;
      let params = {
        orderNum: this.orderNum,
        pageNum: this.pageNum2,
        pageSize: this.pageSize2,
        orderField: this.orderField2,
        isAsc: this.isAsc2,
      };
      this.selectList2 = [];
      this.selectNum2 = 0;
      selectFeeItemOrderList(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.seeShow = true;
          this.data2 = res.data.data.list || [];
          this.obj2 = res.data.data || {};
        } else {
          this.isiconfontshow = false;
          this.seeShow = true;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    toXiang(params) {
      //点击查看详情
      this.orderNum = params.orderNum;
      this.getselectFeeItemOrderList();
      this.showItem = params;
    },
    getselectOrderList() {
      //列表接口
      this.isiconfontshow = true;
      this.selectList = [];
      this.selectNum = 0;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchStr: this.searchValue,
        orderField: this.orderField,
        isAsc: this.isAsc,
      };
      selectOrderList(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          if (res.data.data && res.data.data.list) {
            this.data = res.data.data.list || [];
          } else {
            this.data = [];
          }

          this.obj = res.data.data || {};
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    changesort(item) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.pageNum = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.getselectOrderList();
    },
    changesort2(item) {
      //排序
      this.orderField2 = item.key;
      this.isAsc2 = item.order;
      this.pageNum2 = 1;
      if (item.order == "normal") {
        this.isAsc2 = "";
        this.orderField2 = "";
      }
      this.getselectFeeItemOrderList();
    },
    selectChange(item) {
      //多选选择table'
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    selectChange2(item) {
      //多选选择table'
      this.selectList2 = item;
      this.selectNum2 = this.selectList2.length;
    },
    changepeoplepage(num) {
      //换每页请求多少条
      this.pageSize = num;
      this.pageNum = 1;
      this.getselectOrderList();
    },
    changepeoplepage2(num) {
      //换每页请求多少条
      this.pageSize2 = num;
      this.pageNum2 = 1;
      this.getselectFeeItemOrderList();
    },
    changePeoplecurrent2() {
      this.pageNum2 = num;
      this.getselectFeeItemOrderList();
    },
    changePeoplecurrent(num) {
      //换页
      this.pageNum = num;
      this.getselectOrderList();
    },
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
@import "../font/iconfont.css";
@import "../css/conmmon.scss";
.ivumodal-title-impoet {
  position: absolute;
  top: 15px;
  left: 200px;
  color: #f59a23;
  font-size: 13px;
}
.top {
  width: calc(100% - 250px);
  height: 60px;
  line-height: 35px;
  position: fixed;
  top: 111px;
  z-index: 99;
  background: #fff;
  padding-top: 17px;
  left: 220px;
  padding-left: 15px;
  padding-bottom: 15px;
}
.tuixiang {
  font-family: SimHei;
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  padding: 15px;
  .journal-input {
    width: 250px;
    vertical-align: top;
  }
  .data {
    width: 250px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 15px;
    margin: 40px 0 60px;
  }
}
.page-div {
  width: 100%;
  margin-top: 15px;
  position: fixed;
  background: #fff;
  width: calc(100% - 270px);
  height: 60px;
  z-index: 99;
  bottom: 0;
  padding-top: 15px;
  .page-div-left {
    float: left;
    padding: 5px 10px;
  }
  .page-div-lefts {
    border-right: 1px solid #d7d7d7;
    margin-right: 15px;
  }
  .page-div-page {
    float: right;
    margin-right: 15px;
  }
}
.page-dives {
  width: 100%;
  margin-top: 15px;
  height: 60px;
  z-index: 99;
  bottom: 0;
  padding-top: 15px;
  .page-div-left {
    float: left;
    padding: 5px 10px;
  }
  .page-div-lefts {
    border-right: 1px solid #d7d7d7;
    margin-right: 15px;
  }
  .page-div-page {
    float: right;
    margin-right: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/yuyue/tuixiang.vue